import $ from "jquery";

window.$ = window.jQuery = $;

let firstScriptTag = document.getElementsByTagName( 'script' )[ 0 ];
let tag            = document.createElement( 'script' );
let done           = false;
tag.src            = "https://www.youtube.com/iframe_api";
let player;

firstScriptTag.parentNode.insertBefore( tag, firstScriptTag );

function onPlayerReady( event ) {
	player.playVideo();
}

function stopVideo() {
	player.stopVideo();
}

function onPlayerStateChange( event ) {
	// if ( event.data == YT.PlayerState.PLAYING && !done ) {
	// 	setTimeout( stopVideo, 6000 );
	// 	done = true;
	// }
}

/**
 * Get the youtube video ID from a URL
 *
 * @param url
 * @returns {boolean|*}
 */
function youtubeParser( url ) {
	let regExp = /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
	let match  = url.match( regExp );
	if ( match && match[ 2 ].length == 11 ) {
		return match[ 2 ];
	} else {
		return false;
	}
}

function initModalPlayer( $player ) {
	let $button = $player.find( '.modal-trigger' );
	let width   = $player.data( 'width' ) ? parseInt( $player.data( 'width' ) ) : 968;
	let url     = youtubeParser( $button.data( 'url' ) ) ? youtubeParser( $button.data( 'url' ) ) : false;
	let height  = Math.floor( width / ( 16 / 9 ) );

	$player.attr( 'id', 'modal_' + $button.attr( 'id' ) );
	if ( url ) {
		player = new YT.Player(
			$player.attr( 'id' ), {
				height: height,
				width: width,
				videoId: url,
				modestbranding: 1,
				origin: window.location.origin,
				rel: 0,
				events: {
					'onReady': onPlayerReady,
					'onStateChange': onPlayerStateChange
				}
			}
		);
	}
}

function initPlayer( playerTag ) {
	let $player = $( playerTag );
	let $button = $player.find( '.video__play-button' );
	let width   = $player.data( 'width' ) ? parseInt( $player.data( 'width' ) ) : 968;
	let url     = youtubeParser( $button.data( 'url' ) ) ? youtubeParser( $button.data( 'url' ) ) : false;
	let height  = Math.floor( width / ( 16 / 9 ) );

	if ( !$player.attr( 'id' ) ) {
		$player.attr( 'id', $button.attr( 'id' ) );
	}

	if ( url ) {
		player = new YT.Player(
			$player.attr( 'id' ), {
				height: height,
				width: width,
				videoId: url,
				modestbranding: 1,
				origin: window.location.origin,
				rel: 0,
				events: {
					'onReady': onPlayerReady,
					'onStateChange': onPlayerStateChange
				}
			}
		);
	}
}

/**
 * Put a video in a modal
 *
 * @param player
 */
function openVideoModal( player = {} ) {
	const template = $( "template.video-modal-template" ).html();
	let $modal     = $( template ).clone();
	let $player    = $( player ).clone();

	$modal.find( '.modal__video' ).append( $player );
	let $modalPlayer = $modal.find( '.player' );

	$( "body" ).append( $modal ).addClass( "modal-open" );

	$modal.addClass( 'open' );
	initModalPlayer( $modalPlayer );

	$modal.on(
		"click touch",
		function ( e ) {
			$( "body" ).removeClass( "modal-open" );
			$( ".modal.open" ).remove();
		}
	);
}

window.onYouTubeIframeAPIReady = function () {
	let $players = $( '.player' );

	if ( $players.length > 0 ) {
		$.each(
			$players,
			function ( index, playerTag ) {
				let $playButton = $( playerTag ).find( '.video__play-button' );

				if ( $playButton.length ) {
					$playButton.on(
						'click touch',
						function ( e ) {
							$( '.slides' ).slick( 'slickPause' );
							if ( $playButton.hasClass( 'modal-trigger' ) ) {
								openVideoModal( playerTag );
							} else {
								initPlayer( playerTag );
							}
						}
					);
				}
			}
		);
	}
};
